import {handleGtmEvent} from "@/common/events/gtmEvents";
import {handleFreshworkEvent, freshWorksEvents} from "@/common/events/freshworkEvents";
import {checkFeatureFlag} from "@/common/config/websiteConfig";
import {toastService} from "@/common/events/Toast";

// Function to detect webview context
function isWebViewContext() {
    if (typeof window === 'undefined') return false;
    
    // Check URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("webview")) return true;
    
    // Check cookie
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
        const [name] = cookie.trim().split('=');
        if (name === 'webview_v2') return true;
    }
    
    return false;
}

// Function to get webview trackEvent function
function getWebViewTrackEvent() {
    if (typeof window === 'undefined') return null;
    
    // Check for Android webview
    if (window.Android && typeof window.Android.trackEvent === 'function') {
        return (eventName, payload) => {
            window.Android.trackEvent(eventName, JSON.stringify(payload));
        };
    }
    
    // Check for iOS webview
    if (window.webkit?.messageHandlers?.trackEvent) {
        return (eventName, payload) => {
            window.webkit.messageHandlers.trackEvent.postMessage({
                eventName, 
                payload: JSON.stringify(payload)
            });
        };
    }
    
    return null;
}

if (__IS_CSR__) {
    window.lastEvent = null;
}

/**
 * @param {keyof gtmEvents| keyof freshWorksEvents} event
 * @param {object} data
 */
export function trackEvents(event, data) {
    if (window.lastEvent === event) {
        return;
    }
    window.lastEvent = event;
    setTimeout(() => {
        window.lastEvent = null;
    }, 500);

    // Automatically detect webview and use appropriate tracking
    const isWebView = isWebViewContext();
    const webviewTrackEvent = isWebView ? getWebViewTrackEvent() : null;
    
    if (isWebView && webviewTrackEvent) {
        try {
            // Add console.log and toast service calls like in handleGtmEvent
            webviewTrackEvent(event, data);

            console.log('webview '+ event, JSON.stringify(data));
            toastService.showToast(data, 'webview ' + event);
            
        } catch (error) {
            console.warn('Webview trackEvent failed, falling back to regular tracking:', error);
            // Fall back to regular tracking if webview fails
            handleGtmEvent(event, data);
            checkFeatureFlag("FF_ENABLE_FRESHWORKS_EVENT") && handleFreshworkEvent(event, data);
        }
    } else {
        // Regular tracking for non-webview contexts
        handleGtmEvent(event, data);
        checkFeatureFlag("FF_ENABLE_FRESHWORKS_EVENT") && handleFreshworkEvent(event, data);
    }
}
